import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAzxERVUfVAAa1MVquVe9xroRpg75y-Q5o",
  authDomain: "gogapp-saporu.firebaseapp.com",
  projectId: "gogapp-saporu",
  storageBucket: "gogapp-saporu.firebasestorage.app",
  messagingSenderId: "898554753705",
  appId: "1:898554753705:web:e1ce0808803871482aafb8"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);